import {
  CACHE_TAG_DISPOSAL_TICKET_VERSION_LIST,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
} from 'api/cacheTagTypes'
import { withIdTag } from 'utils/cache'

import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    createWorkOrdersDisposalTicket: builder.mutation({
      query: ({ workOrderId, body }) => ({ url: `/api/v1/core/work-orders/${workOrderId}/disposal-tickets`, method: 'POST', body }),
      invalidatesTags: (result, error, arg) => [
        CACHE_TAG_WORK_ORDER_LIST,
        CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
        CACHE_TAG_ROUTES_STOPS,
        CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET,
        ...withIdTag(CACHE_TAG_DISPOSAL_TICKET_VERSION_LIST, arg.workOrderId),
      ],
    }),
  }),
})

export const { useCreateWorkOrdersDisposalTicketMutation } = extendedApi
